import React from 'react';
import { createRoot } from 'react-dom';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import './utils/authInterceptor';
import App from './App';
import theme from './theme';
import './theme-global.css';
import reportWebVitals from './reportWebVitals';

const root = createRoot(document.getElementById('root'));

root.render(
  <>
    {/* Applies the persisted / system color mode before first paint (no flash). */}
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ChakraProvider theme={theme}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ChakraProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
